/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Chart from "react-apexcharts";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { GetStates } from "../../redux/Slice/Users/StateListSlice";
import { GetEnumsArr } from "../../redux/Slice/Users/EnumsSclice";
import { GetUserRoles } from "../../redux/Slice/Users/RolesSlice";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { Button } from "../../components";
import DatePicker from "react-multi-date-picker";
import { images } from "../../config/images";
import { AllCourtsList } from "../../redux/Slice/Courts/CourtsListSlice";
import { useNavigate } from "react-router-dom";
import {
  GetBookingSummarySportWise,
  GetBookingSummaryTypewise,
  GetDashboardCount,
  GetRevenueSummarySportWise,
  GetRevenueSummaryTypewise,
} from "../../utilities/api/dashboard";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { GetSettings } from "../../redux/Slice/Settings/SettingSlice";

const SuperAdminDashboard = () => {
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const { setting, errorMessage } = useAppSelector((state) => state.settings);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [defaultPeriod, setDefaultPeriod] = useState(
    localStorage.getItem("dashboard-default-date")
      ? localStorage.getItem("dashboard-default-date")
      : "weekly"
  );
  const defaultTd = format(new Date(), "yyyy-MM-dd");

  const [dashboardCount, setDeshboardCount] = useState({
    totalCourts: 0,
    totalSports: 0,
    totalUsers: 0,
  });
  if (errorMessage) {
    toast.error(errorMessage.message)
  }
  useEffect(() => {
    dispatch(GetSettings());
    GetCount();
    dispatch(AllSportsList(""));
    dispatch(GetStates());
    dispatch(GetEnumsArr());
    dispatch(AllFacilitiesList(""));
    dispatch(GetUserRoles());
    dispatch(AllCourtsList({}));

    if (!localStorage.getItem("dashboard-default-date")) {
      localStorage.setItem("dashboard-default-date", JSON.stringify("weekly"));
    }
  }, []);

  useEffect(() => {
    setDefaultPeriod(setting?.dashboardDefaultInterval);
    localStorage.setItem(
      "dashboard-default-date",
      setting?.dashboardDefaultInterval
    );
  }, [setting]);

  useEffect(() => {
    GetLiveBooking();
    GetTotalRevenue();
    GetSportwiseBooking();
    GetSportwiseRevenue();
  }, [SelectedFacility]);

  const getDefaultFd = () => {
    const currentDate = new Date();
    let calculatedFromDate = new Date();

    const formatDate = (newDate: any) => {
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();
      return `${year}-${month}-${day}`;
    };

    switch (defaultPeriod) {
      case "weekly":
        calculatedFromDate.setDate(currentDate.getDate() - 7);
        break;
      case "monthly":
        calculatedFromDate.setMonth(currentDate.getMonth() - 1);
        break;
      case "yearly":
        calculatedFromDate.setFullYear(currentDate.getFullYear() - 1);
        break;
      default:
        calculatedFromDate = currentDate;
        break;
    }
    return formatDate(calculatedFromDate);
  };

  const [date, setDate] = useState({
    liveBookingFd: getDefaultFd(),
    liveBookingTd: defaultTd,
    totalRevenueFd: getDefaultFd(),
    totalRevenueTd: defaultTd,
    sportwiseBookingFd: getDefaultFd(),
    sportwiseBookingTd: defaultTd,
    sportwiseRevenueFd: getDefaultFd(),
    sportwiseRevenueTd: defaultTd,
  });

  let initialState = {
    series: [25, 25, 25, 25],
    options: { labels: [] },
    legend: { show: false },
  };
  const [livebooking, setLiveBooking] = useState({ ...initialState });
  const [totalRevenue, setTotalRevenue] = useState({ ...initialState });
  const [sportWiseBooking, setSportWiseBooking] = useState({ ...initialState });
  const [sportWiseRevenue, setSportWiseRevenue] = useState({ ...initialState });
  const [refreshTime, setRefreshTime] = useState({
    livebookingTime: "",
    totalRevenueTime: "",
    sportWiseBookingTime: "",
    sportWiseRevenueTime: "",
  });
  const [totalBookingCount, setTotalBookingCount] = useState<any>(0);
  const [totalRevenueAmount, setTotalRevenueAmount] = useState<any>(0);
  const [emptyData, setEmptyData] = useState({
    liveBooking: false,
    totalRevenue: false,
    sportwiseBooking: false,
    sportwiseRevenue: false,
  });

  const GetCount = async () => {
    const result = await GetDashboardCount();
    if (result.statusCode === 200) {
      let data = result.data.countsData;
      setDeshboardCount({
        totalCourts: data.totalCourts,
        totalSports: data.totalSports,
        totalUsers: data.totalUsers,
      });
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetLiveBooking = async () => {
    let result = await GetBookingSummaryTypewise(
      date.liveBookingFd,
      date.liveBookingTd,
      SelectedFacility || ""
    );
    if (result.statusCode === 200) {
      const isEmpty = !result.data.summaryData?.length;
      setEmptyData((old) => ({ ...old, liveBooking: isEmpty }));
      setLiveBooking({
        ...livebooking,
        series: result.data.summaryData?.map((item: any) => item.count),
        options: {
          labels: result.data.summaryData?.map((item: any) => item.typeName),
        },
      });
      setRefreshTime((old) => ({
        ...old,
        livebookingTime: format(new Date(), "dd/MM/yyyy hh:mm a"),
      }));
      setTotalBookingCount(
        result.data.summaryData?.reduce(
          (acc: any, cur: any) => Number(acc) + Number(cur.count),
          0
        )
      );
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetTotalRevenue = async () => {
    const result = await GetRevenueSummaryTypewise(
      date.totalRevenueFd,
      date.totalRevenueTd,
      SelectedFacility || ""
    );
    if (result.statusCode === 200) {
      const isEmpty = !result.data.summaryData?.length;
      setEmptyData((old) => ({ ...old, totalRevenue: isEmpty }));
      setTotalRevenue({
        ...totalRevenue,
        series: result.data.summaryData?.map((item: any) =>
          Math.round(item.totalSumAmount)
        ),
        options: {
          labels: result.data.summaryData?.map((item: any) => item.typeName),
        },
      });
      setRefreshTime((old) => ({
        ...old,
        totalRevenueTime: format(new Date(), "dd/MM/yyyy hh:mm a"),
      }));
      setTotalRevenueAmount(
        result.data.summaryData?.reduce(
          (acc: any, cur: any) => Number(acc) + Number(cur.totalSumAmount),
          0
        )
      );
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetSportwiseBooking = async () => {
    const result = await GetBookingSummarySportWise(
      date.sportwiseBookingFd,
      date.sportwiseBookingTd,
      SelectedFacility || ""
    );
    if (result.statusCode === 200) {
      const isEmpty = !result.data.summaryData?.length;
      setEmptyData((old) => ({ ...old, sportwiseBooking: isEmpty }));
      setSportWiseBooking({
        ...sportWiseBooking,
        series: result.data.summaryData?.map((item: any) => item.count),
        options: {
          labels: result.data.summaryData?.map((item: any) => item.sportName),
        },
      });
      setRefreshTime((old) => ({
        ...old,
        sportWiseBookingTime: format(new Date(), "dd/MM/yyyy hh:mm a"),
      }));
    } else {
      toast.error(result.response.data.message);
    }
  };

  const GetSportwiseRevenue = async () => {
    const result = await GetRevenueSummarySportWise(
      date.sportwiseRevenueFd,
      date.sportwiseRevenueTd,
      SelectedFacility || ""
    );
    if (result.statusCode === 200) {
      const isEmpty = !result.data.summaryData?.length;
      setEmptyData((old) => ({ ...old, sportwiseRevenue: isEmpty }));
      setSportWiseRevenue({
        ...sportWiseRevenue,
        series: result.data.summaryData?.map((item: any) => {
          return Math.round(item.totalSumAmount);
        }),
        options: {
          labels: result.data.summaryData?.map((item: any) => item.sportName),
        },
      });
      setRefreshTime((old) => ({
        ...old,
        sportWiseRevenueTime: format(new Date(), "dd/MM/yyyy hh:mm a"),
      }));
    } else {
      toast.error(result.response.data.message);
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <Row className="row-mb align-items-center">
          <Col lg={3}>
            <Card className="shadow-sm count-card">
              <Card.Body>
                <div className="card-text">Active Users</div>
                <div className="card-count">{dashboardCount.totalUsers}</div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3}>
            <Card className="shadow-sm count-card">
              <Card.Body>
                <div className="card-text">Total Sports</div>
                <div className="card-count">{dashboardCount.totalSports}</div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3}>
            <Card className="shadow-sm count-card">
              <Card.Body>
                <div className="card-text">Total Courts</div>
                <div className="card-count">{dashboardCount.totalCourts}</div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3}>
            <Card className="shadow-sm count-card mb-1" onClick={() => navigate("/exit-booking")}>
              <Card.Body className="padding-14">
                <div className="align-items-center card-text d-flex justify-content-center">
                  <span className="icon-exit-booking me-2"></span> Exit Booking
                </div>
              </Card.Body>
            </Card>
            <Card
              className="shadow-sm count-card"
              onClick={() => navigate("/facility-availability-check")}
            >
              <Card.Body className="padding-14">
                <div className="align-items-center card-text d-flex justify-content-center">
                  <span className="icon-facilities me-2"></span> Availability Check
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="g-4">
          <Col lg={6}>
            <Card className="shadow-sm">
              <img
                src={images.refereshchart.default}
                width={30}
                alt="refereshchart"
                className="refresh-chart"
                onClick={() => GetLiveBooking()}
              />
              <Card.Body>
                <Card.Title className="text-start mb-3">
                  Live Booking{"    "}{" "}
                  <span className="fw-semibold fs-7 text-muted">{refreshTime.livebookingTime}</span>
                </Card.Title>
                <Row className="row-mb">
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> From Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          liveBookingFd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.liveBookingFd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      render={<InputIcon className="form-control form-control-sm h-auto" />}
                    />
                  </Col>
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> To Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          liveBookingTd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.liveBookingTd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      minDate={date.liveBookingFd ? new Date(date.liveBookingFd) : undefined}
                      render={
                        <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                      }
                    />
                    <Button
                      onClick={() => GetLiveBooking()}
                      disabled={
                        date.liveBookingFd?.length !== 10 || date.liveBookingTd?.length !== 10
                      }
                      type="button"
                      bname="Go"
                      name="Go-button"
                      id="go-button"
                      className="btn btn-primary btn-sm rounded-1"
                    />
                  </Col>
                </Row>
                <div className="donut" style={{ height: "270px" }}>
                  {emptyData.liveBooking ? (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                      No data found
                    </div>
                  ) : (
                    <Chart
                      options={livebooking.options}
                      series={livebooking.series}
                      type="pie"
                      height="100%"
                    />
                  )}
                </div>
                <Card.Title className="text-start mb-3">
                  Total Bookings:{" "}
                  <span className="fw-semibold fs-7 text-muted">{totalBookingCount}</span>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card className="shadow-sm">
              <img
                src={images.refereshchart.default}
                width={30}
                alt="refereshchart"
                className="refresh-chart"
                onClick={() => GetTotalRevenue()}
              />
              <Card.Body>
                <Card.Title className="text-start mb-3">
                  Total Revenue{"    "}{" "}
                  <span className="fw-semibold fs-7 text-muted">
                    {refreshTime.totalRevenueTime}
                  </span>
                </Card.Title>
                <Row className="row-mb">
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> From Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          totalRevenueFd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.totalRevenueFd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      render={<InputIcon className="form-control form-control-sm h-auto" />}
                    />
                  </Col>
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> To Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          totalRevenueTd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.totalRevenueTd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      minDate={date.totalRevenueFd ? new Date(date.totalRevenueFd) : undefined}
                      render={
                        <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                      }
                    />
                    <Button
                      onClick={() => GetTotalRevenue()}
                      disabled={
                        date.totalRevenueFd?.length !== 10 || date.totalRevenueTd?.length !== 10
                      }
                      type="button"
                      bname="Go"
                      name="Go-button"
                      id="go-button"
                      className="btn btn-primary btn-sm rounded-1"
                    />
                  </Col>
                </Row>
                <div className="donut" style={{ height: "270px" }}>
                  {emptyData.totalRevenue ? (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                      No data found
                    </div>
                  ) : (
                    <Chart
                      options={totalRevenue.options}
                      series={totalRevenue.series}
                      type="pie"
                      height="100%"
                    />
                  )}
                </div>
                <Card.Title className="text-start mb-3">
                  Total Revenue:{" "}
                  <span className="fw-semibold fs-7 text-muted">
                    <span className="rupees-symbol">&#8377;</span> {totalRevenueAmount?.toFixed(2)}
                  </span>
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card className="shadow-sm">
              <img
                src={images.refereshchart.default}
                width={30}
                alt="refereshchart"
                className="refresh-chart"
                onClick={() => GetSportwiseBooking()}
              />
              <Card.Body>
                <Card.Title className="text-start mb-3">
                  Sport-Wise Booking{"    "}{" "}
                  <span className="fw-semibold fs-7 text-muted">
                    {refreshTime.sportWiseBookingTime}
                  </span>
                </Card.Title>
                <Row className="row-mb">
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> From Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          sportwiseBookingFd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.sportwiseBookingFd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      render={<InputIcon className="form-control form-control-sm h-auto" />}
                    />
                  </Col>
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> To Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          sportwiseBookingTd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.sportwiseBookingTd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      minDate={date.sportwiseBookingFd ? new Date(date.sportwiseBookingFd) : undefined}
                      render={
                        <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                      }
                    />
                    <Button
                      onClick={() => GetSportwiseBooking()}
                      disabled={
                        date.sportwiseBookingFd?.length !== 10 ||
                        date.sportwiseBookingTd?.length !== 10
                      }
                      type="button"
                      bname="Go"
                      name="Go-button"
                      id="go-button"
                      className="btn btn-primary btn-sm rounded-1"
                    />
                  </Col>
                </Row>
                <div className="donut" style={{ height: "270px" }}>
                  {emptyData.sportwiseBooking ? (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                      No data found
                    </div>
                  ) : (
                    <Chart
                      options={sportWiseBooking.options}
                      series={sportWiseBooking.series}
                      type="pie"
                      height="100%"
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card className="shadow-sm">
              <img
                src={images.refereshchart.default}
                width={30}
                alt="refereshchart"
                className="refresh-chart"
                onClick={() => GetSportwiseRevenue()}
              />
              <Card.Body>
                <Card.Title className="text-start mb-3">
                  Sport-Wise Booking Revenue{"    "}{" "}
                  <span className="fw-semibold fs-7 text-muted">
                    {refreshTime.sportWiseRevenueTime}
                  </span>
                </Card.Title>
                <Row className="row-mb">
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> From Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          sportwiseRevenueFd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.sportwiseRevenueFd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      render={<InputIcon className="form-control form-control-sm h-auto" />}
                    />
                  </Col>
                  <Col lg={6} className="text-start">
                    <label className="form-label d-block"> To Date : </label>
                    <DatePicker
                      onChange={(e: any) =>
                        setDate({
                          ...date,
                          sportwiseRevenueTd: e?.format("YYYY-MM-DD"),
                        })
                      }
                      value={date.sportwiseRevenueTd?.split("-").reverse().join("-")}
                      format="DD-MM-YYYY"
                      minDate={date.sportwiseRevenueFd ? new Date(date.sportwiseRevenueFd) : undefined}
                      render={
                        <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                      }
                    />
                    <Button
                      onClick={() => GetSportwiseRevenue()}
                      disabled={
                        date.sportwiseRevenueFd?.length !== 10 ||
                        date.sportwiseRevenueTd?.length !== 10
                      }
                      type="button"
                      bname="Go"
                      name="Go-button"
                      id="go-button"
                      className="btn btn-primary btn-sm rounded-1"
                    />
                  </Col>
                </Row>
                <div className="donut" style={{ height: "270px" }}>
                  {emptyData.sportwiseRevenue ? (
                    <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                      No data found
                    </div>
                  ) : (
                    <Chart
                      options={sportWiseRevenue.options}
                      series={sportWiseRevenue.series}
                      type="pie"
                      height="100%"
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <br />
      </Container>
    </>
  );
};
export { SuperAdminDashboard };
